<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="visitPointCreatePermission" id="page-user-edit">
		<vx-card>
			<visit-point-create-tab-account class="mt-4" :data="{}" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import VisitPointCreateTabAccount from "./VisitPointCreateTabAccount.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		VisitPointCreateTabAccount,
		NotPermission,
	},
	computed: {
		visitPointCreatePermission() {
			return this.$store.getters.checkPermission("VISIT_POINT_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
